import { render, staticRenderFns } from "./Strength.vue?vue&type=template&id=cbed3ecc&scoped=true&"
import script from "./Strength.vue?vue&type=script&lang=js&"
export * from "./Strength.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbed3ecc",
  null
  
)

export default component.exports